export const sizes = {
    extraSmall: 'extraSmall',
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const fontSizes = {
    [sizes.extraSmall]: 16,
    [sizes.large]: 48,
    [sizes.medium]: 32,
    [sizes.small]: 24,
};
export const types = {
    account: 'account',
    'account-circle': 'account-circle',
    actionMenu: 'actionMenu',
    add: 'add',
    addressBook: 'addressBook',
    alert: 'alert',
    'arrow-down': 'arrow-down',
    'arrow-down-circle-outline': 'arrow-down-circle-outline',
    'arrow-left': 'arrow-left',
    'arrow-left-alternate': 'arrow-left-alternate',
    'arrow-left-circle': 'arrow-left-circle',
    'arrow-left-circle-outline': 'arrow-left-circle-outline',
    'arrow-right': 'arrow-right',
    'arrow-right-circle': 'arrow-right-circle',
    'arrow-right-circle-outline': 'arrow-right-circle-outline',
    'arrow-up': 'arrow-up',
    'arrow-up-circle-outline': 'arrow-up-circle-outline',
    'attach-horizontal': 'attach-horizontal',
    'attach-vertical': 'attach-vertical',
    auto: 'auto',
    'bell-outline': 'bell-outline',
    'bottom-alignment': 'bottom-alignment',
    calendar: 'calendar',
    camera: 'camera',
    cancel: 'cancel',
    caption: 'caption',
    cart: 'cart',
    'cart-outline': 'cart-outline',
    'center-alignment': 'center-alignment',
    check: 'check',
    'check-circle': 'check-circle',
    'check-circle-outline': 'check-circle-outline',
    circle: 'circle',
    'circle-outline': 'circle-outline',
    clap: 'clap',
    clock: 'clock',
    close: 'close',
    'close-circle': 'close-circle',
    'close-circle-outline': 'close-circle-outline',
    'column-multi': 'column-multi',
    'column-single': 'column-single',
    community: 'community',
    'contact-card': 'contact-card',
    copy: 'copy',
    crop: 'crop',
    'crop-rotate': 'crop-rotate',
    'device-cellphone': 'device-cellphone',
    'device-desktop': 'device-desktop',
    'device-laptop': 'device-laptop',
    'device-tablet': 'device-tablet',
    document: 'document',
    'dots-horizontal': 'dots-horizontal',
    'dots-vertical': 'dots-vertical',
    download: 'download',
    drag: 'drag',
    'drag-horizontal': 'drag-horizontal',
    'drag-vertical': 'drag-vertical',
    editSquare: 'editSquare',
    email: 'email',
    envelopeClosed: 'envelopeClosed',
    envelopeOpen: 'envelopeOpen',
    error: 'error',
    export: 'export',
    express: 'express',
    favorite: 'favorite',
    favorited: 'favorited',
    feed: 'feed',
    file: 'file',
    files: 'files',
    filter: 'filter',
    flash: 'flash',
    'flip-horizontal': 'flip-horizontal',
    'flip-vertical': 'flip-vertical',
    'format-align-center': 'format-align-center',
    'format-align-left': 'format-align-left',
    'format-align-right': 'format-align-right',
    'format-bold': 'format-bold',
    'format-clear': 'format-clear',
    'format-image-align-bottom': 'format-image-align-bottom',
    'format-image-align-left': 'format-image-align-left',
    'format-image-align-right': 'format-image-align-right',
    'format-image-align-top': 'format-image-align-top',
    'format-italic': 'format-italic',
    'format-list-bulleted': 'format-list-bulleted',
    'format-list-numbered': 'format-list-numbered',
    fullscreen: 'fullscreen',
    gift: 'gift',
    giftBag: 'giftBag',
    giftCard: 'giftCard',
    giftMessage: 'giftMessage',
    'go-to-page': 'go-to-page',
    greeting: 'greeting',
    gridViewDefault: 'gridViewDefault',
    gridViewSingle: 'gridViewSingle',
    headset: 'headset',
    help: 'help',
    'horizontal-alignment': 'horizontal-alignment',
    image: 'image',
    'image-caption': 'image-caption',
    'image-plus': 'image-plus',
    import: 'import',
    info: 'info',
    invisible: 'invisible',
    layout: 'layout',
    'left-alignment': 'left-alignment',
    link: 'link',
    'link-off': 'link-off',
    linkCircle: 'linkCircle',
    'load-spinner': 'load-spinner',
    lock: 'lock',
    'lock-open': 'lock-open',
    menu: 'menu',
    'middle-alignment': 'middle-alignment',
    'move-to-top': 'move-to-top',
    occasions: 'occasions',
    'open-in-new': 'open-in-new',
    palette: 'palette',
    paper: 'paper',
    pencil: 'pencil',
    person: 'person',
    'person-edit': 'person-edit',
    'person-group': 'person-group',
    'person-minus': 'person-minus',
    'person-multiple': 'person-multiple',
    'person-plus': 'person-plus',
    phone: 'phone',
    pinterest: 'pinterest',
    'product-landscape-11x14': 'product-landscape-11x14',
    'product-landscape-16x20': 'product-landscape-16x20',
    'product-landscape-18x24': 'product-landscape-18x24',
    'product-portrait-11x14': 'product-portrait-11x14',
    'product-portrait-16x20': 'product-portrait-16x20',
    'product-portrait-18x24': 'product-portrait-18x24',
    'product-portrait-7x2.5': 'product-portrait-7x2.5',
    'product-portrait-7x5': 'product-portrait-7x5',
    'product-portrait-8x10': 'product-portrait-8x10',
    'product-portrait-grand-calendar': 'product-portrait-grand-calendar',
    'product-portrait-standard-calendar': 'product-portrait-standard-calendar',
    recipientAddress: 'recipientAddress',
    recycle: 'recycle',
    redo: 'redo',
    reload: 'reload',
    reply: 'reply',
    returnAddress: 'returnAddress',
    'right-alignment': 'right-alignment',
    rotate: 'rotate',
    'rotate-left': 'rotate-left',
    'rotate-right': 'rotate-right',
    rss: 'rss',
    save: 'save',
    search: 'search',
    settings: 'settings',
    shape: 'shape',
    share: 'share',
    'sidebar-narrow': 'sidebar-narrow',
    'sidebar-wide': 'sidebar-wide',
    'size-ratios': 'size-ratios',
    'social-facebook': 'social-facebook',
    'social-facebook-outline': 'social-facebook-outline',
    'social-facebook-rounded': 'social-facebook-rounded',
    'social-instagram': 'social-instagram',
    'social-instagram-outline': 'social-instagram-outline',
    'social-pinterest': 'social-pinterest',
    'social-pinterest-outline': 'social-pinterest-outline',
    'social-twitter': 'social-twitter',
    'social-twitter-outline': 'social-twitter-outline',
    star: 'star',
    'star-outline': 'star-outline',
    startMonth: 'startMonth',
    subtract: 'subtract',
    tiktok: 'tiktok',
    timer: 'timer',
    'top-alignment': 'top-alignment',
    trash: 'trash',
    truck: 'truck',
    type: 'type',
    undo: 'undo',
    'unfold-less-horizontal': 'unfold-less-horizontal',
    'unfold-less-vertical': 'unfold-less-vertical',
    'unfold-more-horizontal': 'unfold-more-horizontal',
    'unfold-more-vertical': 'unfold-more-vertical',
    upload: 'upload',
    'vertical-alignment': 'vertical-alignment',
    'video-circle': 'video-circle',
    visible: 'visible',
    warning: 'warning',
    zoomIn: 'zoomIn',
};
